import { Component, OnInit, ViewChild, DebugElement } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { BackendApiService } from '../../../app/services/backend-api.service';
// import { BaseUrlConstantsService } from '../../../services/base-url-constants.service';
// import { ConvertDatetimePipe } from '../../../convert-datetime.pipe';
import * as moment from 'moment-timezone';
import { CommonModule } from '@angular/common';


@Component({
  selector: 'app-deep-detail-info',
  templateUrl: './deep-detail-info.component.html',
  styleUrls: ['./deep-detail-info.component.scss'],
  standalone: true,
  imports: [CommonModule]
})
export class DeepDetailInfoComponent implements OnInit {
  // @ViewChild(BaseChartDirective, { static: true }) chart: BaseChartDirective;
  // public Spectral_Analysis_Data = BaseUrlConstantsService.Spectral_Analysis_Data;
  // public bearing_url_detail = BaseUrlConstantsService.BEARING_DETAIL;
  // public Predominent_Freq = BaseUrlConstantsService.PREDOMINENT_FREQ;
  // public Fft_List = BaseUrlConstantsService.FFT_LIST;
  // public sensorData = BaseUrlConstantsService.Sensor_Data;
  // public accelsensorData = BaseUrlConstantsService.TRENDS_DATA;
  // public lineChartData: ChartDataSets[] = [];
  // public lineChartLabels: Label[] = [];
  // public showgraph = false;
  // public deviceInformation: any;
  // public _line_frequency: any;
  // public _rated_rpm: any;
  // public _actualrpm: any;
  // public _unbalanceNoData: any;
  // public _misalignmentNoData: any;
  // public _loosenessNoData: any;
  // public _lvoltageNoData: any;
  // public _driveEndNoData: any;
  // public _nonDriveNoData: any;
  // public deviceId: any;
  // public lineChartLegend = true;
  // public Unbalanceloader: any;
  // public lineChartType = 'line';
  // public lineChartPlugins = [];
  // public breadcrumbsArray: any = [{
  //   page_ref: 'device-reports',
  //   page_title: 'ASSETS'
  // }, {
  //   page_ref: 'user-device-info-new',
  //   page_title: 'Trend Analysis'
  // }, {
  //   page_ref: '#',
  //   page_title: 'Spectral Analysis'
  // }];
  // public freqTableData = [];
  // public xaxisdata = [];
  // public yaxisdata = [];
  // public zaxisdata = [];
  // public xaxisFrequency = [];
  // public yaxisFrequency = [];
  // public zaxisFrequency = [];
  // public chartBoxVisibility = false;
  // public nameDevice: any;
  // public errorStatus: any;
  // public deviceStatus: any;
  // public _status: any;
  // public _devStaus: any;
  // public _offlineStatus: any;
  // public asetId: any;
  // public _ffteError: any = '';
  // public _fftDate: any = null;
  // public noRecordsDiv: boolean = false;
  // public bearingFaults: any = [];
  // public bearingFaultsNds: any = [];
  // public showNoRecords: any;
  // public showNoRecordsnds: any;
  // public bearingErrors: any = null;
  // public _sliderStart: any = undefined;
  // public _sliderEnd: any = undefined;
  // public fftgrapgloader: boolean = false;
  // public _unbalanceLoader: any;
  // public _misalignmentLoader: any;
  // public _loosenessLoader: any;
  // public _lvoltageLoader: any;
  // public _driveEndLoader: any;
  // public _nonDriveLoader: any;
  // public predominentloader: any;
  // tabColor = '1week';
  // dayValue = 24;
  // weekValue: number;
  // monthValue: number;
  // valueType = 'month';
  // selectValue = null;
  // btnColour = '#dedede';
  // btnColor2 = '#ffffff';
  // fweek: boolean;
  // fmonth: boolean;
  // fmonths: boolean;
  // fyear: boolean;
  // rawValue: any;
  // public showUnbalanceGraph: boolean = false;
  // public _filteredRecords: any = [];
  // _timeOut: any = undefined;
  // public trendAnalysData: any = [];
  // siteName: any;
  // appMacAdd: any;
  // serialNumber: any;
  // _lastUpdate: any;
  // applicationNme: any;
  // fftTime: any;
  // fftDataTime: any = null;

  constructor(public router: Router, private service: BackendApiService, public activeRoute: ActivatedRoute) {
    // activeRoute.queryParams.subscribe(params => {
    //   this.deviceId = params[`deviceID`];
    //   this.fftTime = params[`fftTime`];

    //   this.fftDataTime = params[`fftDataTime`];
    //   this.rawValue = this.fftDataTime;
    //   this.asetId = params[`assetid`];
    //   //this.getFrequentDetail(this.deviceId,undefined);
    //   this.nameDevice = params[`nameDevice`];
    //   this.errorStatus = params[`errorStatus`];
    //   this.deviceStatus = params[`deviceStatus`];
    //   this._status = params[`onOffStatus`];
    //   this._devStaus = params[`deviceCurrentStatus`];
    //   this._offlineStatus = params[`sinceDate`];
    //   this._lastUpdate = params[`lastUpdate`];
    // });
  }

  // goToPageLink(name: string) {
  //   const navigationExtras = {
  //     skipLocationChange: true,
  //     queryParams: {
  //       deviceId: this.deviceId,
  //       assetid: this.asetId,
  //       deviceName: this.nameDevice,
  //       errorStatus: this.errorStatus,
  //       deviceStatus: this.deviceStatus
  //     }
  //   };
  //   this.router.navigate([name], navigationExtras);
  // }


  ngOnInit() {
  //   localStorage.setItem('filterVal', null);
  //   this.getFftList();
  //   this.loadFftInfo();
  //   // this._line_frequency = parseInt(localStorage.getItem('lineFreq'));
  //   // tslint:disable-next-line: radix
  //   // this._rated_rpm = parseInt(localStorage.getItem('rated_rpm'));
  //   this.siteName = localStorage.getItem('siteName');
  //   this.appMacAdd = localStorage.getItem('appMacAdd');
  //   this.serialNumber = localStorage.getItem('serialNumber');
  //   this.applicationNme = localStorage.getItem('applicationName');
  //   this.getFrequentDetail(this.deviceId, this.fftTime);
  //   this.bearingDetail(this.fftTime)

  }

  // bearingDetail(rawid) {
  //   this.service.getDataWithQuery(this.bearing_url_detail + "/" + rawid).then(res => {
  //     let result = JSON.parse(JSON.stringify(res)).data;
  //     if (result.code === 200) {
  //       this.bearingFaults = result.body[0];
  //       this.bearingFaultsNds = result.body[1];
  //       if (this.bearingFaults.value.length === 0) {
  //         this.showNoRecords = true;
  //       }
  //       else {
  //         this.showNoRecords = false;
  //       }
  //       if (this.bearingFaultsNds.value.length === 0) {
  //         this.showNoRecordsnds = true;
  //       }
  //       else {
  //         this.showNoRecordsnds = false;
  //       }
  //     }
  //   });
  // }

  // ngOnDestroy() {
  //   if (this._timeOut !== undefined) {
  //     clearInterval(this._timeOut);
  //   }
  // }

  // loadFftInfo() {
  //   if (this._timeOut !== undefined) {
  //     clearTimeout(this._timeOut);
  //   }
  //   this.fftStatusInfo();
  //   let self = this;
  //   self._timeOut = setInterval(function () {
  //     self.fftStatusInfo();
  //   }, 60000);
  // }

  // getFftList() {
  //   let self = this;
  //   let response: any;
  //   const body = {
  //     deviceid: this.deviceId,
  //     assetid: this.asetId
  //   };
  //   this.service.getDataWithQuery(this.Fft_List + "/" + this.deviceId + "/" + this.asetId).then(res => {
  //     this.chartBoxVisibility = true;
  //     response = JSON.parse(JSON.stringify(res)).data;
  //     if (JSON.parse(JSON.stringify(res)).data.status === 'fail') {
  //       const msgErr = response.body.message;
  //       this.service.showError(msgErr);
  //     } else if (response.status === 'success') {
  //       var newArr = response.body.map(function(val, index){ 
  //         var ffttestDateUtc = moment.utc(val.fft_time);
  //         var localDatefft = ffttestDateUtc.local();
  //         let fftTIME = new ConvertDatetimePipe().convertDateTime(localDatefft);
  //         return {key:index, label:val.label +''+ fftTIME, fft_time: val.fft_time, line_freq: val.line_freq, rated_rpm: val.rated_rpm, actual_rpm: val.actual_rpm, value: val.value }; 
  //     }) 
  //     this.trendAnalysData = newArr;
  //       this.loadFftData(this.fftTime);
  //     }
  //   });
  // }

  // fftStatusInfo() {
  //   let self = this;
  //   let response: any;
  //   const body = {
  //     deviceid: parseInt(this.deviceId),
  //     assetid: parseInt(this.asetId),
  //     datafrequency: parseInt(localStorage.getItem('dataFrq'))
  //   };
  //   this.service.getDataWithQuery(this.sensorData + "/" + parseInt(this.deviceId) + "/" + parseInt(this.asetId)).then(res => {
  //     this.chartBoxVisibility = true;
  //     response = JSON.parse(JSON.stringify(res)).data;
  //     if (JSON.parse(JSON.stringify(res)).data.status === 'fail') {
  //       const msgErr = response.body.message;
  //       this.service.showError(msgErr);
  //     } else if (response.status === 'success') {     
  //       this._status = response.body.issue.status;
  //       this._offlineStatus = response.body.issue.offlinestatus;
  //       this.loadDataByfilterType(response.body.issue.filterType);
  //       if (this._status === 'Offline') {
  //         this._devStaus = 'Last';
  //       } else {
  //         this._devStaus = 'Latest';
  //       }
  //     }
  //   });
  // }

  // loadDataByfilterType(filterType) {
  //   let _timeInterval = localStorage.getItem('filterVal');
  //   if (_timeInterval === 'null') {
  //     if (filterType === 'month') {
  //       this.fweek = true;
  //       this.fmonth = false;
  //       this.fmonths = false;
  //       this.fyear = false;
  //       this.selectItem('1month');
  //     } else if (filterType === 'months') {
  //       this.fweek = true;
  //       this.fmonth = true;
  //       this.fmonths = false;
  //       this.fyear = false;
  //       this.selectItem('3month');
  //     } else if (filterType === 'week' || filterType === 'day') {
  //       this.fweek = false;
  //       this.fmonth = false;
  //       this.fmonths = false;
  //       this.fyear = false;
  //       this.selectItem('1week');
  //     } else if (filterType === 'year') {
  //       this.fweek = false;
  //       this.fmonth = false;
  //       this.fmonths = false;
  //       this.fyear = false;
  //       this.selectItem('1year');
  //     }
  //   }
  // }

  // loadFftData(value) {
  //   this.fftgrapgloader = true;
  //   this.getFrequentDetail(this.deviceId, value)
  // }

  // getFrequentDetail(id, val) {
  //   this.fftgrapgloader = true;
  //   const SesnsorMaxVals = [];
  //   let self = this;
  //   let _fftTime = val !== undefined ? val : null;
  //   let _timeFft = this.fftDataTime;
  //   if (_fftTime != null && this.trendAnalysData.length > 0) {
  //     const timeFFTNew = this.trendAnalysData.filter(v => parseInt(v.value) === parseInt(_fftTime));
  //     _timeFft = timeFFTNew;
  //   }

  //   this._fftDate = _timeFft[0].label;
  //   this._rated_rpm = _timeFft[0].rated_rpm;
  //   this._line_frequency = _timeFft[0].line_freq;
  //   this._actualrpm = _timeFft[0].actual_rpm;
  //   this._ffteError = _timeFft[0].error;

  //   let response: any;
  //   const body = {
  //     deviceid: id,
  //     assetid: this.asetId,
  //     ffttime: _fftTime
  //   };
  //   this.service.getDataWithQuery(this.Spectral_Analysis_Data + "/" + id + "/" + this.asetId + "/" + _fftTime).then(res => {
  //     this.fftgrapgloader = false;
  //     this.chartBoxVisibility = true;
  //     this.showgraph = true;
  //     response = JSON.parse(JSON.stringify(res)).data;
  //     if (JSON.parse(JSON.stringify(res)).data.status === 'fail') {
  //       const msgErr = response.body.message;
  //       this.service.showError(msgErr);
  //     }
  //     else if (response.body.message === 'No results found') {
  //       this.noRecordsDiv = true;
  //       self.predominentFreq(id, _fftTime);
  //     }
  //     else if (response.status === 'success') {
  //       if (response.body.error !== null) {
  //         this._ffteError = response.body.error;
  //       }
  //       if (response.body.chartdata.length > 0) {
  //         this.noRecordsDiv = false;
  //         let dash_container = document.getElementById('dashboard_div_fft');
  //         let myDashboard = new (<any>google.visualization).Dashboard(dash_container);
  //         let data: any = google.visualization.arrayToDataTable(response.body.chartdata);
  //         let minData = response.body.chartdata[1][0];
  //         let maxData = response.body.chartdata[response.body.chartdata.length - 1][0];
  //         var interval = 25;
  //         var vTicks = [];
  //         for (var i = response.body.min; i <= response.body.max + interval; i = i + interval) {
  //           vTicks.push(i);
  //         }
  //         var formatter = new google.visualization.NumberFormat({ suffix: ' Hz' });
  //         formatter.format(data, 0);
  //         let options = {
  //           displayAnnotations: true,
  //           hAxis: {
  //             ticks: vTicks,
  //             textStyle: {
  //               fontSize: 9,
  //             },
  //           },
  //           vAxis: {
  //             textStyle: {
  //               fontSize: 9,
  //             },
  //           },
  //           series: {
  //             0: { color: 'blue' },
  //             1: { color: 'yellow' },
  //             2: { color: '#dc3912' }
  //           },
  //           legend: { alignment: 'end', position: 'top', textStyle: { fontSize: 12 } },
  //           chartArea: { width: "100%", left: '4%' },
  //           height: 450,
  //           width: '100%',
  //         };
  //         let container = document.getElementById('chart_div_fft');
  //         let myLine = new google.visualization.ChartWrapper({
  //           'chartType': 'ComboChart',
  //           'containerId': 'chart_div_fft',
  //           'options': options,
  //           'view': { 'columns': [0, 1, 2, 3] }
  //         });
  //         if (this._sliderStart !== undefined && this._sliderEnd !== undefined) {
  //           if (this._filteredRecords[0] === minData && this._filteredRecords[this._filteredRecords.length - 1] === maxData) {
  //             this._filteredRecords = vTicks;
  //           }
  //           myLine.setOption('hAxis.ticks', this._filteredRecords);
  //         }
  //         let myDateSlider = new (<any>google.visualization).ControlWrapper({
  //           'controlType': 'ChartRangeFilter',
  //           'containerId': 'control_div_fft',
  //           'options': {
  //             'filterColumnIndex': 0,
  //             'ui': {
  //               chartOptions: {
  //                 chartArea: {
  //                   left: '4%',
  //                   width: '95.3%',
  //                 },
  //                 series: {
  //                   0: { color: 'blue' },
  //                   1: { color: 'yellow' },
  //                   2: { color: '#dc3912' }
  //                 }
  //               },
  //             },
  //           },
  //           'state': {
  //             range: {
  //               start: this._sliderStart !== undefined ? this._sliderStart : minData,
  //               end: this._sliderEnd !== undefined ? this._sliderEnd : maxData
  //             }
  //           },
  //         });

  //         myDashboard.bind([myDateSlider], myLine);
  //         myDashboard.draw(data, options);

  //         var columns = [];
  //         var series = {};
  //         var chartSeries = (<any>myLine.getOptions()).series;
  //         for (let i = 0; i < data.getNumberOfColumns(); i++) {
  //           columns.push(i);
  //           if (i > 0) {

  //             if (chartSeries != undefined)
  //               series[i - 1] = (chartSeries[i - 1] == undefined ? {} : chartSeries[i - 1]);
  //             else
  //               series[i - 1] = {};
  //           }
  //         }

  //         google.visualization.events.addListener(myLine, 'select', function () {
  //           var sel = myDashboard.getSelection();
  //           // if selection length is 0, we deselected an element
  //           if (sel.length > 0) {
  //             myDateSlider.setState({
  //               range: {
  //                 start: self._sliderStart !== undefined ? self._sliderStart : minData,
  //                 end: self._sliderEnd !== undefined ? self._sliderEnd : maxData
  //               }
  //             });

  //             // if row is undefined, we clicked on the legend
  //             if (sel[0].row === null) {
  //               var col = sel[0].column;
  //               if (columns[col] == col) {
  //                 // hide the data series
  //                 columns[col] = {
  //                   label: data.getColumnLabel(col),
  //                   type: data.getColumnType(col),
  //                   calc: function () {
  //                     return null;
  //                   }
  //                 };
  //                 // grey out the legend entry
  //                 series[col - 1].color = '#CCCCCC';
  //               }
  //               else {
  //                 // show the data series
  //                 columns[col] = col;
  //                 series[col - 1].color = null;
  //               }
  //               let seriesOpt = {
  //                 0: { color: 'blue' },
  //                 1: { color: 'yellow' },
  //                 2: { color: '#dc3912' }
  //               };
  //               var seriesOld = (<any>myLine.getOptions()).series;
  //               for (var key in seriesOld) {
  //                 series[key] = seriesOld[key];
  //                 if (series[key].color == null) {
  //                   series[key].color = seriesOpt[key].color;
  //                 }
  //               }
  //               myLine.setOption('series', series);

  //               var view = new google.visualization.DataView(data);
  //               view.setColumns(columns);

  //               myDashboard.bind([myDateSlider], myLine);
  //               myDashboard.draw(view, options);
  //               myDateSlider.draw();
  //             }
  //           }
  //         });

  //         google.visualization.events.addListener(myDateSlider, 'statechange', function (e) {
  //           var filteredData = myLine.getDataTable().getDistinctValues(0);
  //           self._filteredRecords = filteredData;
  //           if (filteredData[0] === minData && e.startChanged === true && filteredData[filteredData.length - 1] === maxData) {
  //             filteredData = vTicks;
  //           }
  //           else if (filteredData[filteredData.length - 1] === maxData && e.endChanged === true && filteredData[0] === minData) {
  //             filteredData = vTicks;
  //           }
  //           myLine.setOption('hAxis.ticks', filteredData);
  //           let stateDate = myDateSlider.getState();
  //           self._sliderStart = stateDate.range.start;
  //           self._sliderEnd = stateDate.range.end;
  //           myLine.draw();

  //         });
  //         self.predominentFreq(id, _fftTime);
  //       }
  //     }
  //   });
  // }

  // loadAllGraphs() {
  //   this.getUnbalancedCharts();
  //   this.getMisalignedCharts();
  //   this.getLoosenessCharts();
  //   this.getVoltageCharts();
  //   this.motorBearingDriveEnd();
  //   this.motorBearingNonDriveEnd();
  // }

  // selectItem(value) {
  //   localStorage.setItem('filterVal', value);
  //   switch (value) {
  //     case '1week':
  //       this.selectValue = 24;
  //       this.valueType = 'hour';
  //       this.loadAllGraphs();
  //       this.tabColor = value;
  //       break;
  //     case '1month':
  //       this.selectValue = 24;
  //       this.valueType = 'days';
  //       this.loadAllGraphs();
  //       this.tabColor = value;
  //       break;
  //     case '3month':
  //       this.selectValue = 24;
  //       this.valueType = 'week';
  //       this.loadAllGraphs();
  //       this.tabColor = value;
  //       break;
  //     case '1year':
  //       this.selectValue = 24;
  //       this.valueType = 'month';
  //       this.loadAllGraphs();
  //       this.tabColor = value;
  //       break;
  //   }
  // }



  // predominentFreq(id, val) {
  //   let response: any;
  //   let _fftTime = val;
  //   const body = {
  //     deviceid: id,
  //     assetid: this.asetId,
  //     ffttime: _fftTime,
  //     sensorids: [16, 17, 18]
  //   };
  //   this.predominentloader = true;
  //   this.service.getDataWithQuery(this.Predominent_Freq+"/"+[16, 17, 18]+"/"+ _fftTime).then(res => {
  //     this.predominentloader = false;
  //     this.chartBoxVisibility = true;
  //     response = JSON.parse(JSON.stringify(res)).data;
  //     if (JSON.parse(JSON.stringify(res)).data.status === 'fail') {
  //       const msgErr = response.body.message;
  //       this.service.showError(msgErr);
  //     } else if (response.status === 'success') {
  //       // this.bearingFaults = response.body.bearingds;
  //       // this.bearingFaultsNds = response.body.bearingnds;
  //       // if (this.bearingFaults.actualrpm !== null && this.bearingFaults.actualrpm !== '') {
  //       //   this._actualrpm = this.bearingFaults.actualrpm;
  //       // }
  //       // if (this.bearingFaults.error !== '' && this.bearingFaults.error !== null) {
  //       //   this._ffteError = this._ffteError !== '' ? this._ffteError + ',' : this._ffteError;
  //       //   this._ffteError = this._ffteError.concat(' ' + this.bearingFaults.error);
  //       // }
  //       // if (this.bearingFaultsNds.error !== '' && this.bearingFaultsNds.error !== null) {
  //       //   this._ffteError = this._ffteError !== '' ? this._ffteError + ',' : this._ffteError;
  //       //   this._ffteError = this._ffteError.concat(this.bearingFaultsNds.error);
  //       // }

  //       // if (this.bearingFaults.value.length === 0) {
  //       //   this.showNoRecords = true;
  //       // }
  //       // else {
  //       //   this.showNoRecords = false;
  //       // }
  //       // if (this.bearingFaultsNds.value.length === 0) {
  //       //   this.showNoRecordsnds = true;
  //       // }
  //       // else {
  //       //   this.showNoRecordsnds = false;
  //       // }
  //       this.xaxisFrequency = response.body;
  //       if (response.body.length !== 0) {
  //         // tslint:disable-next-line: prefer-for-of
  //         for (let i = 0; i < response.body.length; i++) {
  //           if (typeof (response.body[i].freq) === 'number') {
  //             response.body[i].freq = response.body[i].freq.toFixed(2);
  //           }
  //           if (typeof (response.body[i]['Acceleration 1 X']) === 'number') {
  //             response.body[i]['Acceleration 1 X'] = response.body[i]['Acceleration 1 X'].toFixed(2);
  //           }
  //           if (typeof (response.body[i]['Acceleration 1 Y']) === 'number') {
  //             response.body[i]['Acceleration 1 Y'] = response.body[i]['Acceleration 1 Y'].toFixed(2);
  //           }
  //           if (typeof (response.body[i]['Acceleration 1 Z']) === 'number') {
  //             response.body[i]['Acceleration 1 Z'] = response.body[i]['Acceleration 1 Z'].toFixed(2);
  //           }
  //         }
  //       }
  //     }
  //   });
  // }

  // async getUnbalancedCharts() {
  //   this._unbalanceNoData = true;
  //   let response: any;
  //   this._unbalanceLoader = true;
  //   const body = {
  //     deviceid: parseInt(this.deviceId),
  //     assetid: parseInt(this.asetId),
  //     sensorinterval: 24,//this.selectValue === null ? 24 : this.selectValue,
  //     sensordetailtype: this.valueType,
  //     sensorids: [6, 7, 8],
  //     timezone: localStorage.getItem('clientTimeZone'),
  //     api_type: "history",
  //     trendtype: "unbalance"
  //   };
  //   this.service.getDataWithQuery(this.accelsensorData + "/" + parseInt(this.deviceId) + "/" + parseInt(this.asetId) + "/" + "unbalance").then(res => {
  //     this._unbalanceLoader = false;
  //     this.chartBoxVisibility = true;
  //     response = JSON.parse(JSON.stringify(res)).data;
  //     if (response.status === 'fail') {
  //       const msgErr = response.body.message;
  //       this._unbalanceNoData = false;
  //       this.service.showError(msgErr);
  //     } else if (response.status === 'success') {
  //       if (response.body.message === 'No results found') {
  //         this._unbalanceNoData = false;
  //         this.showUnbalanceGraph = false;
  //       } else {
  //         let thresholdVals = [];
  //         thresholdVals = response.body.threshold;
  //         const xArrVal = [];
  //         if (response.body.chartdata !== 0) {
  //           this._unbalanceNoData = true;
  //           this.showUnbalanceGraph = true;
  //           let newArray = response.body.chartdata.map((currentValue) => {
  //             if (currentValue[0] !== "time") {
  //               currentValue[0] = new Date(currentValue[0]);
  //               return currentValue;
  //             }
  //             else {
  //               return currentValue;
  //             }
  //           });
  //           let minData = newArray[1][0];
  //           let maxData = newArray[newArray.length - 1][0];
  //           let dash_container = document.getElementById('dashunbalanced_div');
  //           let myDashboard = new (<any>google.visualization).Dashboard(dash_container);
  //           let data: any = google.visualization.arrayToDataTable(newArray);
  //           let options = {
  //             legend: { alignment: 'end', position: 'top', textStyle: { fontSize: 12 } },
  //             chartArea: { left: '2%', width: '73%' },
  //             height: 400,
  //             displayAnnotations: true,
  //             displayZoomButtons: false,
  //             displayLegendValues: true,
  //             responsive: true,

  //             vAxis: {
  //               format: 0,
  //               viewWindow: {
  //                 min: response.body.min,
  //                 max: response.body.max
  //               },
  //             },
  //             hAxis: { gridlines: { color: 'transparent' } },
  //             isStacked: true,
  //             series: {
  //               0: { color: 'blue' },
  //               1: { color: 'yellow' },
  //               2: { color: '#dc3912' },
  //               3: { type: 'area', color: '#7FF6A1', visibleInLegend: false, enableInteractivity: false, lineWidth: 0.1 },
  //               4: { type: 'area', color: 'yellow', visibleInLegend: false, enableInteractivity: false, lineWidth: 0.1 },
  //               5: { type: 'area', color: 'red', visibleInLegend: false, enableInteractivity: false, lineWidth: 0.1 }
  //             },
  //             seriesType: 'line',
  //             trendlines: {
  //               0: { color: '#265284', visibleInLegend: false, enableInteractivity: false, lineWidth: 1, id: '1' },
  //               1: { color: '#ecd519', visibleInLegend: false, enableInteractivity: false, lineWidth: 1, id: '2' },
  //               2: { color: '#e8a9a9', visibleInLegend: false, enableInteractivity: false, lineWidth: 1, id: '3' }
  //             }
  //           };


  //           let container = document.getElementById('chartunbalaced_div');
  //           let myLine = new google.visualization.ChartWrapper({
  //             'chartType': 'ComboChart',
  //             'containerId': 'chartunbalaced_div',
  //             'options': options,
  //             'view': {},

  //           });
  //           let myDateSlider = new (<any>google.visualization).ControlWrapper({
  //             'controlType': 'ChartRangeFilter',
  //             'containerId': 'control_div_unbalanced',
  //             'options': {
  //               'filterColumnIndex': 0,
  //               'ui': {
  //                 chartOptions: {
  //                   chartArea: {
  //                     left: '2%',
  //                     width: '73%'
  //                   },
  //                   series: {
  //                     0: { color: 'blue' },
  //                     1: { color: 'yellow' },
  //                     2: { color: '#dc3912' }
  //                   }
  //                 }
  //               }
  //             },
  //           });

  //           google.visualization.events.addListener(myLine, 'ready', function () {
  //             var pathElements = container.getElementsByTagName('path');
  //             Array.prototype.forEach.call(pathElements, function (path) {
  //               if (path.getAttribute('stroke') === options.trendlines[0].color) {
  //                 path.setAttribute('stroke-dasharray', '4, 4');
  //               } else if (path.getAttribute('stroke') === options.trendlines[1].color) {
  //                 path.setAttribute('stroke-dasharray', '4, 4');
  //               } else if (path.getAttribute('stroke') === options.trendlines[2].color) {
  //                 path.setAttribute('stroke-dasharray', '4, 4');
  //               }
  //             });
  //           });

  //           myDashboard.bind([myDateSlider], myLine);
  //           myDashboard.draw(data, options);

  //           var columns = [];
  //           var series = {};
  //           for (var i = 0; i < data.getNumberOfColumns(); i++) {
  //             columns.push(i);
  //             if (i > 0) {
  //               series[i - 1] = {};
  //             }
  //           }

  //           google.visualization.events.addListener(myLine, 'select', function () {
  //             let sel = myDashboard.getSelection();
  //             // if selection length is 0, we deselected an element
  //             if (sel.length > 0) {
  //               // if row is undefined, we clicked on the legend
  //               if (sel[0].row === null) {

  //                 var col = sel[0].column;
  //                 if (columns[col] == col) {
  //                   // hide the data series
  //                   columns[col] = {
  //                     label: data.getColumnLabel(col),
  //                     type: data.getColumnType(col),
  //                     calc: function () {
  //                       return null;
  //                     }
  //                   };

  //                   // grey out the legend entry
  //                   series[col - 1].color = '#CCCCCC';
  //                 }
  //                 else {
  //                   // show the data series
  //                   columns[col] = col;
  //                   series[col - 1].color = null;
  //                 }

  //                 let seriesOpt = {
  //                   0: { color: 'blue' },
  //                   1: { color: 'yellow' },
  //                   2: { color: '#dc3912' },
  //                   3: { type: 'area', color: '#7FF6A1', visibleInLegend: false, enableInteractivity: false, lineWidth: 0.1 },
  //                   4: { type: 'area', color: 'yellow', visibleInLegend: false, enableInteractivity: false, lineWidth: 0.1 },
  //                   5: { type: 'area', color: 'red', visibleInLegend: false, enableInteractivity: false, lineWidth: 0.1 }
  //                 };
  //                 var seriesOld = (<any>myLine.getOptions()).series;
  //                 for (var key in seriesOld) {
  //                   series[key] = seriesOld[key];
  //                   if (series[key].color == null) {
  //                     series[key].color = seriesOpt[key].color;
  //                   }
  //                 }
  //                 // set series option

  //                 myLine.setOption('series', series);

  //                 var view = new google.visualization.DataView(data);
  //                 view.setColumns(columns);
  //                 myDashboard.bind(myDateSlider, myLine);
  //                 myDashboard.draw(view, options);
  //               }
  //             }
  //           });
  //         }
  //       }
  //     }
  //   });
  // }

  // async getMisalignedCharts() {
  //   let response: any;
  //   this._misalignmentNoData = true;
  //   this._misalignmentLoader = true;
  //   const body = {
  //     deviceid: parseInt(this.deviceId),
  //     assetid: parseInt(this.asetId),
  //     sensorinterval: 24,//this.selectValue === null ? 24 : this.selectValue,
  //     sensordetailtype: this.valueType,
  //     sensorids: [6, 7, 8],
  //     timezone: localStorage.getItem('clientTimeZone'),
  //     api_type: "history",
  //     trendtype: "misalignment"
  //   };
  //   this.service.getDataWithQuery(this.accelsensorData + "/" + parseInt(this.deviceId) + "/" + parseInt(this.asetId) + "/" + "misalignment").then(res => {
  //     // this.service.postData(this.accelsensorData, body).then(res => {
  //     this._misalignmentLoader = false;
  //     this.chartBoxVisibility = true;
  //     response = JSON.parse(JSON.stringify(res)).data;
  //     if (JSON.parse(JSON.stringify(res)).data.status === 'fail') {
  //       this._misalignmentNoData = false;
  //       const msgErr = response.body.message;
  //       this.service.showError(msgErr);
  //     } else if (response.status === 'success') {
  //       if (response.body.message === 'No results found') {
  //         this._misalignmentNoData = false;
  //         //this._status = response.body.status;
  //         //this._offlineStatus = response.body.offlinestatus;
  //         //if (this._status === 'Offline') {
  //         //  this._devStaus = 'Last';
  //         //} else {
  //         //  this._devStaus = 'Latest';
  //         //}
  //         this.showUnbalanceGraph = false;
  //       } else {
  //         let thresholdVals = [];
  //         thresholdVals = response.body.threshold;
  //         const xArrVal = [];
  //         if (response.body.chartdata !== 0) {
  //           this._misalignmentNoData = true;
  //           this.showUnbalanceGraph = true;
  //           let newArray = response.body.chartdata.map((currentValue) => {
  //             if (currentValue[0] !== "time") {
  //               currentValue[0] = new Date(currentValue[0]);
  //               return currentValue;
  //             }
  //             else {
  //               return currentValue;
  //             }
  //           });
  //           let minData = newArray[1][0];
  //           let maxData = newArray[newArray.length - 1][0];
  //           let dash_container = document.getElementById('dashmisaligned_div');
  //           let myDashboard = new (<any>google.visualization).Dashboard(dash_container);
  //           let data: any = google.visualization.arrayToDataTable(newArray);
  //           let options = {
  //             legend: { alignment: 'end', position: 'top', textStyle: { fontSize: 12 } },
  //             chartArea: { left: '2%', width: '73%' },
  //             height: 400,
  //             displayAnnotations: true,
  //             displayZoomButtons: false,
  //             displayLegendValues: true,
  //             responsive: true,

  //             vAxis: {
  //               format: 0,
  //               viewWindow: {
  //                 min: response.body.min,
  //                 max: response.body.max
  //               },
  //             },
  //             hAxis: { gridlines: { color: 'transparent' } },
  //             isStacked: true,
  //             series: {
  //               0: { color: 'blue' },
  //               1: { color: 'yellow' },
  //               2: { color: '#dc3912' },
  //               3: { type: 'area', color: '#7FF6A1', visibleInLegend: false, enableInteractivity: false, lineWidth: 0.1 },
  //               4: { type: 'area', color: 'yellow', visibleInLegend: false, enableInteractivity: false, lineWidth: 0.1 },
  //               5: { type: 'area', color: 'red', visibleInLegend: false, enableInteractivity: false, lineWidth: 0.1 }
  //             },
  //             seriesType: 'line',
  //             trendlines: {
  //               0: { color: '#265284', visibleInLegend: false, enableInteractivity: false, lineWidth: 1, id: '1' },
  //               1: { color: '#ecd519', visibleInLegend: false, enableInteractivity: false, lineWidth: 1, id: '2' },
  //               2: { color: '#e8a9a9', visibleInLegend: false, enableInteractivity: false, lineWidth: 1, id: '3' }
  //             }
  //           };


  //           let container = document.getElementById('chartmisaligned_div');
  //           let myLine = new google.visualization.ChartWrapper({
  //             'chartType': 'ComboChart',
  //             'containerId': 'chartmisaligned_div',
  //             'options': options,
  //             'view': {},

  //           });
  //           let myDateSlider = new (<any>google.visualization).ControlWrapper({
  //             'controlType': 'ChartRangeFilter',
  //             'containerId': 'control_div_misaligned',
  //             'options': {
  //               'filterColumnIndex': 0,
  //               'ui': {
  //                 chartOptions: {
  //                   chartArea: {
  //                     left: '2%',
  //                     width: '73%'
  //                   },
  //                   series: {
  //                     0: { color: 'blue' },
  //                     1: { color: 'yellow' },
  //                     2: { color: '#dc3912' }
  //                   }
  //                 }
  //               }
  //             },
  //           });

  //           google.visualization.events.addListener(myLine, 'ready', function () {
  //             var pathElements = container.getElementsByTagName('path');
  //             Array.prototype.forEach.call(pathElements, function (path) {
  //               if (path.getAttribute('stroke') === options.trendlines[0].color) {
  //                 path.setAttribute('stroke-dasharray', '4, 4');
  //               } else if (path.getAttribute('stroke') === options.trendlines[1].color) {
  //                 path.setAttribute('stroke-dasharray', '4, 4');
  //               } else if (path.getAttribute('stroke') === options.trendlines[2].color) {
  //                 path.setAttribute('stroke-dasharray', '4, 4');
  //               }
  //             });
  //           });

  //           myDashboard.bind([myDateSlider], myLine);
  //           myDashboard.draw(data, options);

  //           var columns = [];
  //           var series = {};
  //           for (var i = 0; i < data.getNumberOfColumns(); i++) {
  //             columns.push(i);
  //             if (i > 0) {
  //               series[i - 1] = {};
  //             }
  //           }

  //           google.visualization.events.addListener(myLine, 'select', function () {
  //             let sel = myDashboard.getSelection();
  //             // if selection length is 0, we deselected an element
  //             if (sel.length > 0) {
  //               // if row is undefined, we clicked on the legend
  //               if (sel[0].row === null) {

  //                 var col = sel[0].column;
  //                 if (columns[col] == col) {
  //                   // hide the data series
  //                   columns[col] = {
  //                     label: data.getColumnLabel(col),
  //                     type: data.getColumnType(col),
  //                     calc: function () {
  //                       return null;
  //                     }
  //                   };

  //                   // grey out the legend entry
  //                   series[col - 1].color = '#CCCCCC';
  //                 }
  //                 else {
  //                   // show the data series
  //                   columns[col] = col;
  //                   series[col - 1].color = null;
  //                 }

  //                 let seriesOpt = {
  //                   0: { color: 'blue' },
  //                   1: { color: 'yellow' },
  //                   2: { color: '#dc3912' },
  //                   3: { type: 'area', color: '#7FF6A1', visibleInLegend: false, enableInteractivity: false, lineWidth: 0.1 },
  //                   4: { type: 'area', color: 'yellow', visibleInLegend: false, enableInteractivity: false, lineWidth: 0.1 },
  //                   5: { type: 'area', color: 'red', visibleInLegend: false, enableInteractivity: false, lineWidth: 0.1 }
  //                 };
  //                 var seriesOld = (<any>myLine.getOptions()).series;
  //                 for (var key in seriesOld) {
  //                   series[key] = seriesOld[key];
  //                   if (series[key].color == null) {
  //                     series[key].color = seriesOpt[key].color;
  //                   }
  //                 }
  //                 // set series option

  //                 myLine.setOption('series', series);

  //                 var view = new google.visualization.DataView(data);
  //                 view.setColumns(columns);
  //                 myDashboard.bind(myDateSlider, myLine);
  //                 myDashboard.draw(view, options);
  //               }
  //             }
  //           });
  //         }
  //       }

  //     }
  //   });
  // }

  // async getLoosenessCharts() {
  //   let response: any;
  //   this._loosenessNoData = true;
  //   this._loosenessLoader = true;
  //   const body = {
  //     deviceid: parseInt(this.deviceId),
  //     assetid: parseInt(this.asetId),
  //     sensorinterval: 24,//this.selectValue === null ? 24 : this.selectValue,
  //     sensordetailtype: this.valueType,
  //     sensorids: [6, 7, 8],
  //     timezone: localStorage.getItem('clientTimeZone'),
  //     api_type: "history",
  //     trendtype: "looseness"
  //   };
  //   this.service.getDataWithQuery(this.accelsensorData + "/" + parseInt(this.deviceId) + "/" + parseInt(this.asetId) + "/" + "looseness").then(res => {
  //     // this.service.postData(this.accelsensorData, body).then(res => {
  //     this._loosenessLoader = false;
  //     this.chartBoxVisibility = true;
  //     response = JSON.parse(JSON.stringify(res)).data;
  //     if (JSON.parse(JSON.stringify(res)).data.status === 'fail') {
  //       this._loosenessNoData = false;
  //       const msgErr = response.body.message;
  //       this.service.showError(msgErr);
  //     } else if (response.status === 'success') {
  //       if (response.body.message === 'No results found') {
  //         this._loosenessNoData = false;

  //         this.showUnbalanceGraph = false;
  //       } else {
  //         let thresholdVals = [];
  //         thresholdVals = response.body.threshold;
  //         const xArrVal = [];
  //         if (response.body.chartdata !== 0) {
  //           this._loosenessNoData = true;
  //           this.showUnbalanceGraph = true;
  //           let newArray = response.body.chartdata.map((currentValue) => {
  //             if (currentValue[0] !== "time") {
  //               currentValue[0] = new Date(currentValue[0]);
  //               return currentValue;
  //             }
  //             else {
  //               return currentValue;
  //             }
  //           });
  //           let minData = newArray[1][0];
  //           let maxData = newArray[newArray.length - 1][0];
  //           let dash_container = document.getElementById('dashlooseness_div');
  //           let myDashboard = new (<any>google.visualization).Dashboard(dash_container);
  //           let data: any = google.visualization.arrayToDataTable(newArray);
  //           let options = {
  //             legend: { alignment: 'end', position: 'top', textStyle: { fontSize: 12 } },
  //             chartArea: { left: '2%', width: '73%' },
  //             height: 400,
  //             displayAnnotations: true,
  //             displayZoomButtons: false,
  //             displayLegendValues: true,
  //             responsive: true,

  //             vAxis: {
  //               format: 0,
  //               viewWindow: {
  //                 min: response.body.min,
  //                 max: response.body.max
  //               },
  //             },
  //             hAxis: { gridlines: { color: 'transparent' } },
  //             isStacked: true,
  //             series: {
  //               0: { color: 'blue' },
  //               1: { color: 'yellow' },
  //               2: { color: '#dc3912' },
  //               3: { color: '#7FF6A1' },
  //               4: { color: 'green' },
  //               5: { color: 'black' }
  //             },
  //             seriesType: 'line',
  //             trendlines: {
  //               0: { color: '#265284', visibleInLegend: false, enableInteractivity: false, lineWidth: 1, id: '1' },
  //               1: { color: '#ecd519', visibleInLegend: false, enableInteractivity: false, lineWidth: 1, id: '2' },
  //               2: { color: '#e8a9a9', visibleInLegend: false, enableInteractivity: false, lineWidth: 1, id: '3' },
  //               3: { color: '#7FF6A1', visibleInLegend: false, enableInteractivity: false, lineWidth: 1, id: '4' },
  //               4: { color: 'green', visibleInLegend: false, enableInteractivity: false, lineWidth: 1, id: '5' },
  //               5: { color: 'black', visibleInLegend: false, enableInteractivity: false, lineWidth: 1, id: '6' }
  //             }
  //           };


  //           let container = document.getElementById('chartlooseness_div');
  //           let myLine = new google.visualization.ChartWrapper({
  //             'chartType': 'ComboChart',
  //             'containerId': 'chartlooseness_div',
  //             'options': options,
  //             'view': {},

  //           });
  //           let myDateSlider = new (<any>google.visualization).ControlWrapper({
  //             'controlType': 'ChartRangeFilter',
  //             'containerId': 'control_div_looseness',
  //             'options': {
  //               'filterColumnIndex': 0,
  //               'ui': {
  //                 chartOptions: {
  //                   chartArea: {
  //                     left: '2%',
  //                     width: '73%'
  //                   },
  //                   series: {
  //                     0: { color: 'blue' },
  //                     1: { color: 'yellow' },
  //                     2: { color: '#dc3912' },
  //                     3: { color: '#7FF6A1' },
  //                     4: { color: 'green' },
  //                     5: { color: 'black' }
  //                   }
  //                 }
  //               }
  //             },
  //           });

  //           google.visualization.events.addListener(myLine, 'ready', function () {
  //             var pathElements = container.getElementsByTagName('path');
  //             Array.prototype.forEach.call(pathElements, function (path) {
  //               if (path.getAttribute('stroke') === options.trendlines[0].color) {
  //                 path.setAttribute('stroke-dasharray', '4, 4');
  //               } else if (path.getAttribute('stroke') === options.trendlines[1].color) {
  //                 path.setAttribute('stroke-dasharray', '4, 4');
  //               } else if (path.getAttribute('stroke') === options.trendlines[2].color) {
  //                 path.setAttribute('stroke-dasharray', '4, 4');
  //               }
  //             });
  //           });

  //           myDashboard.bind([myDateSlider], myLine);
  //           myDashboard.draw(data, options);

  //           var columns = [];
  //           var series = {};
  //           for (var i = 0; i < data.getNumberOfColumns(); i++) {
  //             columns.push(i);
  //             if (i > 0) {
  //               series[i - 1] = {};
  //             }
  //           }

  //           google.visualization.events.addListener(myLine, 'select', function () {
  //             let sel = myDashboard.getSelection();
  //             // if selection length is 0, we deselected an element
  //             if (sel.length > 0) {
  //               // if row is undefined, we clicked on the legend
  //               if (sel[0].row === null) {

  //                 var col = sel[0].column;
  //                 if (columns[col] == col) {
  //                   // hide the data series
  //                   columns[col] = {
  //                     label: data.getColumnLabel(col),
  //                     type: data.getColumnType(col),
  //                     calc: function () {
  //                       return null;
  //                     }
  //                   };

  //                   // grey out the legend entry
  //                   series[col - 1].color = '#CCCCCC';
  //                 }
  //                 else {
  //                   // show the data series
  //                   columns[col] = col;
  //                   series[col - 1].color = null;
  //                 }

  //                 let seriesOpt = {
  //                   0: { color: 'blue' },
  //                   1: { color: 'yellow' },
  //                   2: { color: '#dc3912' },
  //                   3: { color: '#7FF6A1' },
  //                   4: { color: 'green' },
  //                   5: { color: 'black' }
  //                 };
  //                 var seriesOld = (<any>myLine.getOptions()).series;
  //                 for (var key in seriesOld) {
  //                   series[key] = seriesOld[key];
  //                   if (series[key].color == null) {
  //                     series[key].color = seriesOpt[key].color;
  //                   }
  //                 }
  //                 // set series option

  //                 myLine.setOption('series', series);

  //                 var view = new google.visualization.DataView(data);
  //                 view.setColumns(columns);
  //                 myDashboard.bind(myDateSlider, myLine);
  //                 myDashboard.draw(view, options);
  //               }
  //             }
  //           });
  //         }
  //       }

  //     }
  //   });
  // }

  // async getVoltageCharts() {
  //   let response: any;
  //   this._lvoltageNoData = true;
  //   this._lvoltageLoader = true;
  //   const body = {
  //     deviceid: parseInt(this.deviceId),
  //     assetid: parseInt(this.asetId),
  //     sensorinterval: 24,//this.selectValue === null ? 24 : this.selectValue,
  //     sensordetailtype: this.valueType,
  //     sensorids: [6, 7, 8],
  //     timezone: localStorage.getItem('clientTimeZone'),
  //     api_type: "history",
  //     trendtype: "lvunbalance"
  //   };
  //   this.service.getDataWithQuery(this.accelsensorData + "/" + parseInt(this.deviceId) + "/" + parseInt(this.asetId) + "/" + "lvunbalance").then(res => {
  //     // this.service.postData(this.accelsensorData, body).then(res => {
  //     this._lvoltageLoader = false;
  //     this.chartBoxVisibility = true;
  //     response = JSON.parse(JSON.stringify(res)).data;
  //     if (JSON.parse(JSON.stringify(res)).data.status === 'fail') {
  //       this._lvoltageNoData = false;
  //       const msgErr = response.body.message;
  //       this.service.showError(msgErr);
  //     } else if (response.status === 'success') {
  //       if (response.body.message === 'No results found') {
  //         this._lvoltageNoData = false;
  //         this.showUnbalanceGraph = false;
  //       } else {

  //         let thresholdVals = [];
  //         thresholdVals = response.body.threshold;
  //         const xArrVal = [];
  //         if (response.body.chartdata !== 0) {
  //           this._lvoltageNoData = true;
  //           this.showUnbalanceGraph = true;
  //           let newArray = response.body.chartdata.map((currentValue) => {
  //             if (currentValue[0] !== "time") {
  //               currentValue[0] = new Date(currentValue[0]);
  //               return currentValue;
  //             }
  //             else {
  //               return currentValue;
  //             }
  //           });
  //           let minData = newArray[1][0];
  //           let maxData = newArray[newArray.length - 1][0];
  //           let dash_container = document.getElementById('dashvoltage_div');
  //           let myDashboard = new (<any>google.visualization).Dashboard(dash_container);
  //           let data: any = google.visualization.arrayToDataTable(newArray);
  //           let options = {
  //             legend: { alignment: 'end', position: 'top', textStyle: { fontSize: 12 } },
  //             chartArea: { left: '2%', width: '73%' },
  //             height: 400,
  //             displayAnnotations: true,
  //             displayZoomButtons: false,
  //             displayLegendValues: true,
  //             responsive: true,

  //             vAxis: {
  //               format: 0,
  //               viewWindow: {
  //                 min: response.body.min,
  //                 max: response.body.max
  //               },
  //             },
  //             hAxis: { gridlines: { color: 'transparent' } },
  //             isStacked: true,
  //             series: {
  //               0: { color: 'blue' },
  //               1: { color: 'yellow' },
  //               2: { color: '#dc3912' },
  //               3: { type: 'area', color: '#7FF6A1', visibleInLegend: false, enableInteractivity: false, lineWidth: 0.1 },
  //               4: { type: 'area', color: 'yellow', visibleInLegend: false, enableInteractivity: false, lineWidth: 0.1 },
  //               5: { type: 'area', color: 'red', visibleInLegend: false, enableInteractivity: false, lineWidth: 0.1 }
  //             },
  //             seriesType: 'line',
  //             trendlines: {
  //               0: { color: '#265284', visibleInLegend: false, enableInteractivity: false, lineWidth: 1, id: '1' },
  //               1: { color: '#ecd519', visibleInLegend: false, enableInteractivity: false, lineWidth: 1, id: '2' },
  //               2: { color: '#e8a9a9', visibleInLegend: false, enableInteractivity: false, lineWidth: 1, id: '3' }
  //             }
  //           };


  //           let container = document.getElementById('chartvoltage_div');
  //           let myLine = new google.visualization.ChartWrapper({
  //             'chartType': 'ComboChart',
  //             'containerId': 'chartvoltage_div',
  //             'options': options,
  //             'view': {},

  //           });
  //           let myDateSlider = new (<any>google.visualization).ControlWrapper({
  //             'controlType': 'ChartRangeFilter',
  //             'containerId': 'control_div_voltage',
  //             'options': {
  //               'filterColumnIndex': 0,
  //               'ui': {
  //                 chartOptions: {
  //                   chartArea: {
  //                     left: '2%',
  //                     width: '73%'
  //                   },
  //                   series: {
  //                     0: { color: 'blue' },
  //                     1: { color: 'yellow' },
  //                     2: { color: '#dc3912' }
  //                   }
  //                 }
  //               }
  //             },
  //           });

  //           google.visualization.events.addListener(myLine, 'ready', function () {
  //             var pathElements = container.getElementsByTagName('path');
  //             Array.prototype.forEach.call(pathElements, function (path) {
  //               if (path.getAttribute('stroke') === options.trendlines[0].color) {
  //                 path.setAttribute('stroke-dasharray', '4, 4');
  //               } else if (path.getAttribute('stroke') === options.trendlines[1].color) {
  //                 path.setAttribute('stroke-dasharray', '4, 4');
  //               } else if (path.getAttribute('stroke') === options.trendlines[2].color) {
  //                 path.setAttribute('stroke-dasharray', '4, 4');
  //               }
  //             });
  //           });

  //           myDashboard.bind([myDateSlider], myLine);
  //           myDashboard.draw(data, options);

  //           var columns = [];
  //           var series = {};
  //           for (var i = 0; i < data.getNumberOfColumns(); i++) {
  //             columns.push(i);
  //             if (i > 0) {
  //               series[i - 1] = {};
  //             }
  //           }

  //           google.visualization.events.addListener(myLine, 'select', function () {
  //             let sel = myDashboard.getSelection();
  //             // if selection length is 0, we deselected an element
  //             if (sel.length > 0) {
  //               // if row is undefined, we clicked on the legend
  //               if (sel[0].row === null) {

  //                 var col = sel[0].column;
  //                 if (columns[col] == col) {
  //                   // hide the data series
  //                   columns[col] = {
  //                     label: data.getColumnLabel(col),
  //                     type: data.getColumnType(col),
  //                     calc: function () {
  //                       return null;
  //                     }
  //                   };

  //                   // grey out the legend entry
  //                   series[col - 1].color = '#CCCCCC';
  //                 }
  //                 else {
  //                   // show the data series
  //                   columns[col] = col;
  //                   series[col - 1].color = null;
  //                 }

  //                 let seriesOpt = {
  //                   0: { color: 'blue' },
  //                   1: { color: 'yellow' },
  //                   2: { color: '#dc3912' },
  //                   3: { type: 'area', color: '#7FF6A1', visibleInLegend: false, enableInteractivity: false, lineWidth: 0.1 },
  //                   4: { type: 'area', color: 'yellow', visibleInLegend: false, enableInteractivity: false, lineWidth: 0.1 },
  //                   5: { type: 'area', color: 'red', visibleInLegend: false, enableInteractivity: false, lineWidth: 0.1 }
  //                 };
  //                 var seriesOld = (<any>myLine.getOptions()).series;
  //                 for (var key in seriesOld) {
  //                   series[key] = seriesOld[key];
  //                   if (series[key].color == null) {
  //                     series[key].color = seriesOpt[key].color;
  //                   }
  //                 }
  //                 // set series option

  //                 myLine.setOption('series', series);

  //                 var view = new google.visualization.DataView(data);
  //                 view.setColumns(columns);
  //                 myDashboard.bind(myDateSlider, myLine);
  //                 myDashboard.draw(view, options);
  //               }
  //             }
  //           });
  //         }
  //       }
  //     }
  //   });
  // }

  // async motorBearingDriveEnd() {
  //   let response: any;
  //   this._driveEndNoData = true;
  //   this._driveEndLoader = true;
  //   const body = {
  //     deviceid: parseInt(this.deviceId),
  //     assetid: parseInt(this.asetId),
  //     sensorinterval: 24,//this.selectValue === null ? 24 : this.selectValue,
  //     sensordetailtype: this.valueType,
  //     sensorids: [6, 7, 8],
  //     timezone: localStorage.getItem('clientTimeZone'),
  //     api_type: "history",
  //     trendtype: "debf"
  //   };
  //   this.service.getDataWithQuery(this.accelsensorData + "/" + parseInt(this.deviceId) + "/" + parseInt(this.asetId) + "/" + "debf").then(res => {
  //   // this.service.postData(this.accelsensorData, body).then(res => {
  //     this._driveEndLoader = false;
  //     this.chartBoxVisibility = true;
  //     response = JSON.parse(JSON.stringify(res)).data;
  //     if (JSON.parse(JSON.stringify(res)).data.status === 'fail') {
  //       this._driveEndNoData = false;
  //       const msgErr = response.body.message;
  //       this.service.showError(msgErr);
  //     } else if (response.status === 'success') {
  //       if (response.body.message === 'No results found') {
  //         this._driveEndNoData = false;
  //         this.showUnbalanceGraph = false;
  //       } else {

  //         let thresholdVals = [];
  //         thresholdVals = response.body.threshold;
  //         const xArrVal = [];
  //         if (response.body.chartdata !== 0) {
  //           this._driveEndNoData = true;
  //           this.showUnbalanceGraph = true;
  //           let newArray = response.body.chartdata.map((currentValue) => {
  //             if (currentValue[0] !== "time") {
  //               currentValue[0] = new Date(currentValue[0]);
  //               return currentValue;
  //             }
  //             else {
  //               return currentValue;
  //             }
  //           });
  //           let minData = newArray[1][0];
  //           let maxData = newArray[newArray.length - 1][0];
  //           let dash_container = document.getElementById('dashdriveend_div');
  //           let myDashboard = new (<any>google.visualization).Dashboard(dash_container);
  //           let data: any = google.visualization.arrayToDataTable(newArray);
  //           let options = {
  //             legend: { alignment: 'end', position: 'top', textStyle: { fontSize: 12 } },
  //             chartArea: { left: '2%', width: '73%' },
  //             height: 400,
  //             displayAnnotations: true,
  //             displayZoomButtons: false,
  //             displayLegendValues: true,
  //             responsive: true,

  //             vAxis: {
  //               format: 0,
  //               viewWindow: {
  //                 min: response.body.min,
  //                 max: response.body.max
  //               },
  //             },
  //             hAxis: { gridlines: { color: 'transparent' } },
  //             isStacked: true,
  //             series: {
  //               0: { color: 'blue' },
  //               1: { color: 'yellow' },
  //               2: { color: '#dc3912' },
  //               3: { type: 'area', color: '#7FF6A1', visibleInLegend: false, enableInteractivity: false, lineWidth: 0.1 },
  //               4: { type: 'area', color: 'yellow', visibleInLegend: false, enableInteractivity: false, lineWidth: 0.1 },
  //               5: { type: 'area', color: 'red', visibleInLegend: false, enableInteractivity: false, lineWidth: 0.1 }
  //             },
  //             seriesType: 'line',
  //             trendlines: {
  //               0: { color: '#265284', visibleInLegend: false, enableInteractivity: false, lineWidth: 1, id: '1' },
  //               1: { color: '#ecd519', visibleInLegend: false, enableInteractivity: false, lineWidth: 1, id: '2' },
  //               2: { color: '#e8a9a9', visibleInLegend: false, enableInteractivity: false, lineWidth: 1, id: '3' }
  //             }
  //           };


  //           let container = document.getElementById('chartdriveend_div');
  //           let myLine = new google.visualization.ChartWrapper({
  //             'chartType': 'ComboChart',
  //             'containerId': 'chartdriveend_div',
  //             'options': options,
  //             'view': {},

  //           });
  //           let myDateSlider = new (<any>google.visualization).ControlWrapper({
  //             'controlType': 'ChartRangeFilter',
  //             'containerId': 'control_div_driveend',
  //             'options': {
  //               'filterColumnIndex': 0,
  //               'ui': {
  //                 chartOptions: {
  //                   chartArea: {
  //                     left: '2%',
  //                     width: '73%'
  //                   },
  //                   series: {
  //                     0: { color: 'blue' },
  //                     1: { color: 'yellow' },
  //                     2: { color: '#dc3912' }
  //                   }
  //                 }
  //               }
  //             },
  //           });

  //           google.visualization.events.addListener(myLine, 'ready', function () {
  //             var pathElements = container.getElementsByTagName('path');
  //             Array.prototype.forEach.call(pathElements, function (path) {
  //               if (path.getAttribute('stroke') === options.trendlines[0].color) {
  //                 path.setAttribute('stroke-dasharray', '4, 4');
  //               } else if (path.getAttribute('stroke') === options.trendlines[1].color) {
  //                 path.setAttribute('stroke-dasharray', '4, 4');
  //               } else if (path.getAttribute('stroke') === options.trendlines[2].color) {
  //                 path.setAttribute('stroke-dasharray', '4, 4');
  //               }
  //             });
  //           });

  //           myDashboard.bind([myDateSlider], myLine);
  //           myDashboard.draw(data, options);

  //           var columns = [];
  //           var series = {};
  //           for (var i = 0; i < data.getNumberOfColumns(); i++) {
  //             columns.push(i);
  //             if (i > 0) {
  //               series[i - 1] = {};
  //             }
  //           }

  //           google.visualization.events.addListener(myLine, 'select', function () {
  //             let sel = myDashboard.getSelection();
  //             // if selection length is 0, we deselected an element
  //             if (sel.length > 0) {
  //               // if row is undefined, we clicked on the legend
  //               if (sel[0].row === null) {

  //                 var col = sel[0].column;
  //                 if (columns[col] == col) {
  //                   // hide the data series
  //                   columns[col] = {
  //                     label: data.getColumnLabel(col),
  //                     type: data.getColumnType(col),
  //                     calc: function () {
  //                       return null;
  //                     }
  //                   };

  //                   // grey out the legend entry
  //                   series[col - 1].color = '#CCCCCC';
  //                 }
  //                 else {
  //                   // show the data series
  //                   columns[col] = col;
  //                   series[col - 1].color = null;
  //                 }

  //                 let seriesOpt = {
  //                   0: { color: 'blue' },
  //                   1: { color: 'yellow' },
  //                   2: { color: '#dc3912' },
  //                   3: { type: 'area', color: '#7FF6A1', visibleInLegend: false, enableInteractivity: false, lineWidth: 0.1 },
  //                   4: { type: 'area', color: 'yellow', visibleInLegend: false, enableInteractivity: false, lineWidth: 0.1 },
  //                   5: { type: 'area', color: 'red', visibleInLegend: false, enableInteractivity: false, lineWidth: 0.1 }
  //                 };
  //                 var seriesOld = (<any>myLine.getOptions()).series;
  //                 for (var key in seriesOld) {
  //                   series[key] = seriesOld[key];
  //                   if (series[key].color == null) {
  //                     series[key].color = seriesOpt[key].color;
  //                   }
  //                 }
  //                 // set series option

  //                 myLine.setOption('series', series);

  //                 var view = new google.visualization.DataView(data);
  //                 view.setColumns(columns);
  //                 myDashboard.bind(myDateSlider, myLine);
  //                 myDashboard.draw(view, options);
  //               }
  //             }
  //           });
  //         }
  //       }
  //     }
  //   });
  // }

  // async motorBearingNonDriveEnd() {
  //   let response: any;
  //   this._nonDriveNoData = true;
  //   this._nonDriveLoader = true;
  //   const body = {
  //     deviceid: parseInt(this.deviceId),
  //     assetid: parseInt(this.asetId),
  //     sensorinterval: 24,//this.selectValue === null ? 24 : this.selectValue,
  //     sensordetailtype: this.valueType,
  //     sensorids: [6, 7, 8],
  //     timezone: localStorage.getItem('clientTimeZone'),
  //     api_type: "history",
  //     trendtype: "ndebf"
  //   };
  //   this.service.getDataWithQuery(this.accelsensorData + "/" + parseInt(this.deviceId) + "/" + parseInt(this.asetId) + "/" + "ndebf").then(res => {
  //   // this.service.postData(this.accelsensorData, body).then(res => {
  //     this._nonDriveLoader = false;
  //     this.chartBoxVisibility = true;
  //     response = JSON.parse(JSON.stringify(res)).data;
  //     if (JSON.parse(JSON.stringify(res)).data.status === 'fail') {
  //       this._nonDriveNoData = false;
  //       const msgErr = response.body.message;
  //       this.service.showError(msgErr);
  //     } else if (response.status === 'success') {
  //       if (response.body.message === 'No results found') {
  //         this._nonDriveNoData = false;

  //         this.showUnbalanceGraph = false;
  //       } else {

  //         let thresholdVals = [];
  //         thresholdVals = response.body.threshold;
  //         const xArrVal = [];
  //         if (response.body.chartdata !== 0) {
  //           this._nonDriveNoData = true;
  //           this.showUnbalanceGraph = true;
  //           let newArray = response.body.chartdata.map((currentValue) => {
  //             if (currentValue[0] !== "time") {
  //               currentValue[0] = new Date(currentValue[0]);
  //               return currentValue;
  //             }
  //             else {
  //               return currentValue;
  //             }
  //           });
  //           let minData = newArray[1][0];
  //           let maxData = newArray[newArray.length - 1][0];
  //           let dash_container = document.getElementById('dashnondrive_div');
  //           let myDashboard = new (<any>google.visualization).Dashboard(dash_container);
  //           let data: any = google.visualization.arrayToDataTable(newArray);
  //           let options = {
  //             legend: { alignment: 'end', position: 'top', textStyle: { fontSize: 12 } },
  //             chartArea: { left: '2%', width: '73%' },
  //             height: 400,
  //             displayAnnotations: true,
  //             displayZoomButtons: false,
  //             displayLegendValues: true,
  //             responsive: true,

  //             vAxis: {
  //               format: 0,
  //               viewWindow: {
  //                 min: response.body.min,
  //                 max: response.body.max
  //               },
  //             },
  //             hAxis: { gridlines: { color: 'transparent' } },
  //             isStacked: true,
  //             series: {
  //               0: { color: 'blue' },
  //               1: { color: 'yellow' },
  //               2: { color: '#dc3912' },
  //               3: { type: 'area', color: '#7FF6A1', visibleInLegend: false, enableInteractivity: false, lineWidth: 0.1 },
  //               4: { type: 'area', color: 'yellow', visibleInLegend: false, enableInteractivity: false, lineWidth: 0.1 },
  //               5: { type: 'area', color: 'red', visibleInLegend: false, enableInteractivity: false, lineWidth: 0.1 }
  //             },
  //             seriesType: 'line',
  //             trendlines: {
  //               0: { color: '#265284', visibleInLegend: false, enableInteractivity: false, lineWidth: 1, id: '1' },
  //               1: { color: '#ecd519', visibleInLegend: false, enableInteractivity: false, lineWidth: 1, id: '2' },
  //               2: { color: '#e8a9a9', visibleInLegend: false, enableInteractivity: false, lineWidth: 1, id: '3' }
  //             }
  //           };


  //           let container = document.getElementById('chartnondrive_div');
  //           let myLine = new google.visualization.ChartWrapper({
  //             'chartType': 'ComboChart',
  //             'containerId': 'chartnondrive_div',
  //             'options': options,
  //             'view': {},

  //           });
  //           let myDateSlider = new (<any>google.visualization).ControlWrapper({
  //             'controlType': 'ChartRangeFilter',
  //             'containerId': 'control_div_nondrive',
  //             'options': {
  //               'filterColumnIndex': 0,
  //               'ui': {
  //                 chartOptions: {
  //                   chartArea: {
  //                     left: '2%',
  //                     width: '73%'
  //                   },
  //                   series: {
  //                     0: { color: 'blue' },
  //                     1: { color: 'yellow' },
  //                     2: { color: '#dc3912' }
  //                   }
  //                 }
  //               }
  //             },
  //           });

  //           google.visualization.events.addListener(myLine, 'ready', function () {
  //             var pathElements = container.getElementsByTagName('path');
  //             Array.prototype.forEach.call(pathElements, function (path) {
  //               if (path.getAttribute('stroke') === options.trendlines[0].color) {
  //                 path.setAttribute('stroke-dasharray', '4, 4');
  //               } else if (path.getAttribute('stroke') === options.trendlines[1].color) {
  //                 path.setAttribute('stroke-dasharray', '4, 4');
  //               } else if (path.getAttribute('stroke') === options.trendlines[2].color) {
  //                 path.setAttribute('stroke-dasharray', '4, 4');
  //               }
  //             });
  //           });

  //           myDashboard.bind([myDateSlider], myLine);
  //           myDashboard.draw(data, options);

  //           var columns = [];
  //           var series = {};
  //           for (var i = 0; i < data.getNumberOfColumns(); i++) {
  //             columns.push(i);
  //             if (i > 0) {
  //               series[i - 1] = {};
  //             }
  //           }

  //           google.visualization.events.addListener(myLine, 'select', function () {
  //             let sel = myDashboard.getSelection();
  //             // if selection length is 0, we deselected an element
  //             if (sel.length > 0) {
  //               // if row is undefined, we clicked on the legend
  //               if (sel[0].row === null) {

  //                 var col = sel[0].column;
  //                 if (columns[col] == col) {
  //                   // hide the data series
  //                   columns[col] = {
  //                     label: data.getColumnLabel(col),
  //                     type: data.getColumnType(col),
  //                     calc: function () {
  //                       return null;
  //                     }
  //                   };

  //                   // grey out the legend entry
  //                   series[col - 1].color = '#CCCCCC';
  //                 }
  //                 else {
  //                   // show the data series
  //                   columns[col] = col;
  //                   series[col - 1].color = null;
  //                 }

  //                 let seriesOpt = {
  //                   0: { color: 'blue' },
  //                   1: { color: 'yellow' },
  //                   2: { color: '#dc3912' },
  //                   3: { type: 'area', color: '#7FF6A1', visibleInLegend: false, enableInteractivity: false, lineWidth: 0.1 },
  //                   4: { type: 'area', color: 'yellow', visibleInLegend: false, enableInteractivity: false, lineWidth: 0.1 },
  //                   5: { type: 'area', color: 'red', visibleInLegend: false, enableInteractivity: false, lineWidth: 0.1 }
  //                 };
  //                 var seriesOld = (<any>myLine.getOptions()).series;
  //                 for (var key in seriesOld) {
  //                   series[key] = seriesOld[key];
  //                   if (series[key].color == null) {
  //                     series[key].color = seriesOpt[key].color;
  //                   }
  //                 }
  //                 // set series option

  //                 myLine.setOption('series', series);

  //                 var view = new google.visualization.DataView(data);
  //                 view.setColumns(columns);
  //                 myDashboard.bind(myDateSlider, myLine);
  //                 myDashboard.draw(view, options);
  //               }
  //             }
  //           });
  //         }
  //       }
  //     }
  //   });
  // }
}

